import { useQuery } from '@apollo/client'
import { Card, PageHeading, Page } from 'admin-web-ui'
import gql from 'graphql-tag'
import React from 'react'
import { AddAccountUserForm } from './AddAccountUserForm'

export const GET_CUSTOMER = gql`
  query {
    customer {
      projects {
        id
        name
      }
    }
  }
`

export const AddAccountUser = (): React.ReactElement => {
  const { loading, data } = useQuery(GET_CUSTOMER)

  return (
    <Page>
      <PageHeading>Add Account User</PageHeading>
      <Card loading={loading}>
        {data && <AddAccountUserForm projects={data.customer.projects} />}
      </Card>
    </Page>
  )
}
